<div class="tree-container">
    <pm-tree-item [ItemsSource]="ItemsSource"
                  [ItemTemplate]="ItemTemplate || defaultTemplate"
                  [DisplayMemberPath]="DisplayMemberPath"
                  [ChildPath]="ChildPath">
    </pm-tree-item>
</div>



<ng-template #defaultTemplate let-item>
    <div class="tree-item-template" [innerHTML]="getItemDisplay(item) | highlight : Text"></div>
</ng-template>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/tree/tree.html